import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import { TOURNAMENT } from "@/data/tournament";

const SECTIONS = [
  {
    title: "1. Responsable del tratamiento",
    body: `El responsable del tratamiento de los datos personales recogidos a través de este sitio web es la organización de PROXIMA LEAGUE, con sede de actividad en Girona (España). Contacto: ${TOURNAMENT.contactEmail}.`,
  },
  {
    title: "2. Datos que recogemos",
    body: `A través del formulario de inscripción recogemos los siguientes datos: nombre del equipo, nombre y apellidos del capitán, teléfono de contacto, dirección de correo electrónico, ciudad, número aproximado de jugadores (entre 8 y 12) y una breve descripción opcional del equipo.

Además, el formulario permite indicar, mediante una casilla opcional e independiente, si desea recibir comunicaciones sobre futuros torneos.

No recogemos datos de categorías especiales ni datos de menores a través de este formulario.`,
  },
  {
    title: "3. Finalidad y base jurídica",
    body: `Los datos se tratan con las siguientes finalidades:

• Gestionar la solicitud de inscripción y la participación del equipo en el torneo (base jurídica: ejecución de la relación contractual, art. 6.1.b RGPD). La aceptación de esta finalidad es obligatoria para poder tramitar la inscripción (casilla obligatoria del formulario).
• Contactar con el capitán para completar la inscripción y comunicar información organizativa (art. 6.1.b RGPD).
• Publicar información del equipo en la web una vez confirmada la inscripción (base jurídica: consentimiento, art. 6.1.a RGPD, otorgado al marcar la casilla obligatoria del formulario).
• Enviar comunicaciones sobre futuros torneos y novedades de PROXIMA LEAGUE, ÚNICAMENTE si el capitán ha marcado la casilla opcional correspondiente (base jurídica: consentimiento, art. 6.1.a RGPD). Este consentimiento es independiente de la inscripción, no condiciona la participación y puede retirarse en cualquier momento escribiendo a ${TOURNAMENT.contactEmail}.`,
  },
  {
    title: "4. Publicación de datos en la web",
    body: `Una vez confirmada la inscripción, el equipo dispondrá de una página pública propia en este sitio web en la que se mostrarán: el nombre del equipo, el nombre del capitán, la ciudad y el número de jugadores de la plantilla.

Al marcar la casilla de aceptación del formulario de inscripción, el capitán consiente expresamente esta publicación.

El teléfono y el correo electrónico NUNCA se publican: solo son accesibles para la organización con fines de gestión.

El capitán puede retirar este consentimiento en cualquier momento escribiendo a ${TOURNAMENT.contactEmail}, en cuyo caso se retirarán sus datos personales de la página pública del equipo (manteniéndose el nombre del equipo).`,
  },
  {
    title: "5. Plazo de conservación",
    body: `Los datos se conservarán durante la organización y celebración del torneo y, una vez finalizado, durante los plazos necesarios para atender posibles responsabilidades legales derivadas de la participación (incluida la gestión de devoluciones y el seguro de accidentes).`,
  },
  {
    title: "6. Destinatarios",
    body: `Los datos no se ceden a terceros con fines comerciales. Únicamente pueden ser tratados por proveedores que prestan servicios a la organización (por ejemplo, herramientas de gestión interna de inscripciones), que actúan como encargados del tratamiento, y por las entidades necesarias para la prestación del servicio (aseguradora del torneo, en su caso) o por obligación legal.`,
  },
  {
    title: "7. Derechos de las personas interesadas",
    body: `Puede ejercer en cualquier momento sus derechos de acceso, rectificación, supresión, oposición, limitación del tratamiento y portabilidad enviando una solicitud a ${TOURNAMENT.contactEmail}, acompañada de información que permita verificar su identidad.

Asimismo, tiene derecho a presentar una reclamación ante la Agencia Española de Protección de Datos (www.aepd.es) si considera que el tratamiento no se ajusta a la normativa.`,
  },
  {
    title: "8. Actualizaciones",
    body: `Esta política puede actualizarse por exigencias legales u organizativas. La fecha de la última actualización figura al pie de esta página.`,
  },
];

export default function PrivacyPolicyPage() {
  return (
    <div className="bg-[#050505] text-white min-h-screen" data-testid="privacy-policy-page">
      <Navbar />
      <main className="pt-16">
        <section className="relative bg-[#070707] py-24 sm:py-28 border-t border-white/5">
          <div className="max-w-5xl mx-auto px-6 lg:px-8">
            <a
              href="/"
              className="inline-flex items-center gap-2 text-xs tracking-[0.25em] uppercase text-white/40 hover:text-[#EAB308] transition-colors mb-10"
              data-testid="privacy-back-link"
            >
              ← Volver al inicio
            </a>
            <div className="text-xs tracking-[0.3em] uppercase text-[#EAB308] mb-4">
              Marco Legal
            </div>
            <h1 className="font-display text-4xl sm:text-5xl uppercase tracking-tight leading-none mb-4">
              Política de
              <br />
              <span className="text-white/40">Protección de Datos</span>
            </h1>
            <p className="text-white/50 text-sm max-w-2xl mb-12 font-body">
              Información sobre el tratamiento de datos personales de los
              equipos inscritos en PROXIMA LEAGUE, conforme al Reglamento
              General de Protección de Datos (RGPD) y la LOPDGDD.
            </p>

            <div className="space-y-10">
              {SECTIONS.map((s, idx) => (
                <div key={s.title} data-testid={`privacy-section-${idx}`}>
                  <h2 className="font-heading text-base sm:text-lg text-white uppercase tracking-wide mb-3 flex items-center gap-3">
                    <span className="w-6 h-px bg-[#EAB308]" />
                    {s.title}
                  </h2>
                  <p className="text-white/65 font-body text-sm sm:text-base leading-relaxed whitespace-pre-line max-w-3xl">
                    {s.body}
                  </p>
                </div>
              ))}
            </div>

            <div className="mt-14 pt-6 border-t border-white/10 text-[10px] tracking-[0.25em] uppercase text-white/30">
              Última actualización · Junio 2026
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}
